module.exports = __webpack_public_path__ + "img/FB222X2915_3956300.0b3108a4.jpg";